import { useAuthStore } from "../contexts/AuthContext";

/* 
    checkPermission accepts the name of a permission and returns an object
    permission i.e. 'dashboard.edit.all'
    { 
        permitted: false,
        message: ''
    }
*/

export default function useCheckPermission(permissionString) {
    const [ feature, permission, scope ] = permissionString.split('.');
    // ADDED: having useAuthStore requires that the outside function NEEDS to be a React Hook
    // if it is a hook, then I cannot use it in a useEffect because hooks cannot be used in callbacks
    const { user, selectedAccountPermissions } = useAuthStore();
    const result = { permitted: false, message: '' };
    //super admins are currently allowed to do anything
    if (user.isSuperAdmin) {
        result.permitted = true;
        return result;
    }

    //check feature permission
    // const featurePermissions = selectedAccountPermissions.filter(p=>p.featureName === feature);
    const featurePermissions = Object.values(selectedAccountPermissions).filter( p => p.featureName === feature)
    if (featurePermissions.length>0) {

        //check if permission within feature is needed
        if (permission) {

            //check permission within feature
            const featurePermissionMatches = featurePermissions.filter(p=>p.permissionName === permission);
            if (featurePermissionMatches.length>0) {

                //check if scope is needed
                if (scope) {

                    //check scope
                    const scopePermissions = featurePermissionMatches.filter(p=>p.scope === scope);
                    if (scopePermissions.length>0) {

                        //has permission for this scope
                        result.permitted = true;
                    } else {
                        //does not have permission for this scope
                        result.message = scopeAlerts[scope];
                    }
                } else {
                    //no specific scope needed
                    result.permitted = true;
                }
            } else {
                //does not have permission within feature
                result.message = permissionAlerts[permission];
            }
        } else {
            //only needs feature permission
            result.permitted = true;
        }
    } else {
        //does not have feature permission
        result.message = featureAlerts[feature];
    }
    return result;
}


const featureAlerts = {
    dashboard: 'You do not have edit access',
    chart: 'You do not have access to charts',
}

const permissionAlerts = {
    view: 'You do not have view access',
    edit: 'You do not have edit access',
    create: 'You do not have create access',
}

const scopeAlerts = {
    all: 'You do not have access to this item',
    some: 'You do not have access to this item'
}